var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOfficeResidential = function SvgOfficeResidential(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    d: "M13.484 8V5h1v3zM16.483 5v3h1V5zM13.484 13v-3h1v3zM16.483 10v3h1v-3zM13.484 18v-3h1v3zM16.483 15v3h1v-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    fillRule: "evenodd",
    d: "M10.499 3h9.996v17h1.009v1H4.5v-6.026h1V20h4.998zm8.996 1v16h-7.997V4z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    d: "m4.15 13.82 5.91-5.003-.645-.763-5.911 5.002z"
  })));
};
export default SvgOfficeResidential;